module.exports = __webpack_public_path__ + "static/media/class_small_hunter.982db222.png";